
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Repper case-study page behaviour: the click-to-load video facade and the
// data-driven reflection tab sections.
//
// Images/media are imported (not referenced as string paths) so the bundler
// fingerprints them and emits them to the build output.
var $0a186b180cad0227$exports = {};
$0a186b180cad0227$exports = import.meta.resolve("2ncyu");


var $4c41a097efff4ac1$exports = {};
$4c41a097efff4ac1$exports = import.meta.resolve("j7NMr");


var $6c76952859b71e2e$exports = {};
$6c76952859b71e2e$exports = import.meta.resolve("9674T");


var $2bab510c2d628c47$exports = {};
$2bab510c2d628c47$exports = import.meta.resolve("k2SH9");


var $d7f89b20046e29b5$exports = {};
$d7f89b20046e29b5$exports = import.meta.resolve("7ltZP");


var $7778f13d474207da$exports = {};
$7778f13d474207da$exports = import.meta.resolve("5nnnA");


var $b0e1118e6595051d$exports = {};
$b0e1118e6595051d$exports = import.meta.resolve("lN9cK");


var $95b1dfb41efdf1a9$exports = {};
$95b1dfb41efdf1a9$exports = import.meta.resolve("fHYMm");


var $71099c29b7ccf619$exports = {};
$71099c29b7ccf619$exports = import.meta.resolve("7ZKOq");


var $ad157c98769aee8e$exports = {};
$ad157c98769aee8e$exports = import.meta.resolve("agZ8D");


var $3fe04889bc055f90$exports = {};
$3fe04889bc055f90$exports = import.meta.resolve("d6roo");


var $b4e3ba67e4ad10a2$exports = {};
$b4e3ba67e4ad10a2$exports = import.meta.resolve("5MN7h");


// PLACEHOLDER media — point at an existing image until the real assets land.
const $511b1b8aaab0c10e$var$tilingsPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($b4e3ba67e4ad10a2$exports)));
const $511b1b8aaab0c10e$var$preview3dPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($b4e3ba67e4ad10a2$exports)));
/* ── Video facade ─────────────────────────────────────────────────────────
   Keeps the embed chrome minimal until the user hits play, then swaps in the
   real player with native controls + autoplay. */ document.querySelectorAll('.video-facade').forEach((facade)=>{
    facade.addEventListener('click', ()=>{
        const id = facade.dataset.youtubeId;
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`;
        iframe.title = facade.getAttribute('aria-label');
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        facade.replaceWith(iframe);
    });
});
/* ── Reflection tabs ──────────────────────────────────────────────────────
   To edit copy or swap media, only this data structure needs to change.
   media.type is 'image' or 'video'. */ const $511b1b8aaab0c10e$var$reflections = [
    {
        mount: 'iterate-to-learn',
        heading: 'Iterate to learn',
        intro: 'Repper is self-funded and the longest-running project of my studio partnership. It has been a testing ground for developing new skills and learning how product design affects all parts of a business: from business model and marketing to support.',
        tabs: [
            {
                label: '2007',
                title: 'A viral prototype',
                body: 'Seeing my girlfriend struggle to make patterns in Photoshop, I created a interactive experiment in Flash/ActionScript with my studio partner Alexander and threw it online. Online design tools being few and far between on the internet, it got picked up quickly.',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($95b1dfb41efdf1a9$exports))),
                    width: 800,
                    height: 517,
                    alt: "Repper in 2007 \u2014 the original Flash experiment"
                }
            },
            {
                label: '2008',
                title: 'Design, print, profit?',
                body: "Keen to ride the momentum, we polished it (to 00\u2019s standards) and tacked on print-on-demand. People only just started buying books online, so while we were excited about the option, our visitors weren't.",
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($71099c29b7ccf619$exports))),
                    width: 800,
                    height: 517,
                    alt: 'Repper in 2008'
                }
            },
            {
                label: '2009',
                title: 'Desktop app for creatives',
                body: 'What users where in fact looking for was a good design tool for patterns. We turned the web app into a complete desktop app and sold it (way too cheap) to 7,000 customers.',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ad157c98769aee8e$exports))),
                    width: 800,
                    height: 517,
                    alt: 'Repper in 2009'
                }
            },
            {
                label: '2018',
                title: 'One more time with feeling',
                body: 'After a long hiatus, with print-on-demand and online design tools now mainstream, we gave it another go. Built from the ground up with new web tech, it gave power to pros while staying suitable for amateurs. Wrapped in a subscription with cloud storage and device syncing, traction slowly but steadily grew.',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3fe04889bc055f90$exports))),
                    width: 800,
                    height: 517,
                    alt: 'Repper in 2018'
                }
            },
            {
                label: '2022',
                title: 'Iteration makes perfect',
                body: 'The product matured into a very fine pattern-making tool, over time adding unique pattern options, collection management, live 3D preview, and supporting insanely large exports. All this time, we made sure we also kept it accessible for primary school students and elderly creatives.',
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b4e3ba67e4ad10a2$exports))),
                    width: 800,
                    height: 517,
                    alt: 'Repper in 2022'
                }
            },
            {
                label: '2025',
                title: 'More than building software',
                body: "In recent years we've moved our attention from product to community and support. Repper users now have their own forum and we've grown a YouTube channel with 50+ educational videos and 5K subscribers. I've felt the impact of the every good and bad decision in product and business, personally handling over 3,000 support tickets.",
                // PLACEHOLDER asset: using v5 until a 2025 image is supplied
                media: {
                    type: 'image',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6c76952859b71e2e$exports))),
                    width: 800,
                    height: 517,
                    alt: 'Repper in 2025'
                }
            }
        ]
    },
    {
        mount: 'caring-about-the-details',
        heading: 'Caring about the details',
        intro: "In the space of design tools, geometric patterns are a niche of a niche. The small addressable market didn\u2019t stop us from setting the bar high. I wanted to craft a product that\u2019s a joy to use, both fun and productive.",
        tabs: [
            {
                label: 'Core interactions',
                body: 'Controlling the pattern sample and testing it at various formats are core interactions, so we made sure these are smooth and easy, on desktop and tablet.',
                media: {
                    type: 'video',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2bab510c2d628c47$exports))),
                    poster: (0, (/*@__PURE__*/$parcel$interopDefault($d7f89b20046e29b5$exports)))
                }
            },
            {
                label: 'Tiling thumbs',
                body: "We went beyond the usual wallpaper group tilings with many unique pattern options. They're presented with live preview so the user can quickly learn the aesthetic options available.",
                media: {
                    type: 'video',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7778f13d474207da$exports))),
                    poster: (0, (/*@__PURE__*/$parcel$interopDefault($b0e1118e6595051d$exports)))
                }
            },
            {
                label: '3D preview',
                body: 'Many of our customers work with print-on-demand. The photo-realistic preview helps the user evaluate the pattern in context, with the option to live edit. The smart backdrop provides an automatically matching background.',
                media: {
                    type: 'video',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($0a186b180cad0227$exports))),
                    poster: (0, (/*@__PURE__*/$parcel$interopDefault($4c41a097efff4ac1$exports)))
                }
            }
        ]
    }
];
// width/height attributes let the browser reserve the aspect-ratio box before
// the image loads, so the panel doesn't jump in height once it arrives.
const $511b1b8aaab0c10e$var$dims = (media)=>media.width && media.height ? ` width="${media.width}" height="${media.height}"` : '';
const $511b1b8aaab0c10e$var$mediaMarkup = (media)=>media.type === 'video' ? `<video controls playsinline poster="${media.poster ?? ''}" src="${media.src}"${$511b1b8aaab0c10e$var$dims(media)}></video>` : `<img src="${media.src}" alt="${media.alt ?? ''}"${$511b1b8aaab0c10e$var$dims(media)} />`;
// An optional title shows inline, in the default text color, before an em dash.
const $511b1b8aaab0c10e$var$bodyMarkup = (tab)=>tab.title ? `<span class="reflection-panel__title">${tab.title}</span> \u{2014} ${tab.body}` : tab.body;
const $511b1b8aaab0c10e$var$renderPanel = (panel, tab)=>{
    panel.innerHTML = `
    <div class="reflection-panel__body">${$511b1b8aaab0c10e$var$bodyMarkup(tab)}</div>
    <div class="reflection-panel__media">${$511b1b8aaab0c10e$var$mediaMarkup(tab.media)}</div>`;
};
$511b1b8aaab0c10e$var$reflections.forEach((section)=>{
    const root = document.querySelector(`.reflection-tabs[data-reflection="${section.mount}"]`);
    if (!root) return;
    const heading = document.createElement('h2');
    heading.className = 'reflection-tabs__heading';
    heading.textContent = section.heading;
    const lead = document.createElement('p');
    lead.className = 'reflection-tabs__lead';
    lead.textContent = section.intro;
    const tabbar = document.createElement('div');
    tabbar.className = 'reflection-tabbar';
    tabbar.setAttribute('role', 'tablist');
    const panel = document.createElement('div');
    panel.className = 'reflection-panel';
    panel.setAttribute('role', 'tabpanel');
    const buttons = section.tabs.map((tab, i)=>{
        const button = document.createElement('button');
        button.className = 'reflection-tab';
        button.type = 'button';
        button.textContent = tab.label;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-selected', String(i === 0));
        button.addEventListener('click', ()=>{
            buttons.forEach((b)=>b.setAttribute('aria-selected', 'false'));
            button.setAttribute('aria-selected', 'true');
            $511b1b8aaab0c10e$var$renderPanel(panel, tab);
        });
        tabbar.appendChild(button);
        return button;
    });
    // Append in reading order (heading → lead → tabs → panel); grid areas place them.
    root.append(heading, lead, tabbar, panel);
    $511b1b8aaab0c10e$var$renderPanel(panel, section.tabs[0]);
});


//# sourceMappingURL=repper.cbb50cdc.js.map
